<template>
	<div class="other_page_r">
		<el-card class="card_box">
			<div slot="header" class="card_title">
				<span>内容管理/AI专题</span>
			</div>
			<div>
				<el-form :inline="true" :model="searchInfo" class="demo-form-inline">
					<el-form-item label="专题ID">
						<el-input
							class="custom_input_60"
							v-model="searchInfo.id"
							placeholder=""
						>
						</el-input>
					</el-form-item>
					<el-form-item label="专题名称">
						<el-input
							class="custom_input_100"
							v-model="searchInfo.title"
							placeholder=""
						>
						</el-input>
					</el-form-item>

					<el-form-item label="状态">
						<el-select
							class="custom_input_120"
							v-model="searchInfo.status"
							placeholder=""
						>
							<el-option label="全部" value="999"></el-option>
							<el-option label="已发布" value="1"></el-option>
							<el-option label="草稿箱" value="0"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item>
						<el-button class="search-btn" type="primary" @click="searchBtn"
							>查询</el-button
						>
						<el-button class="search-btn" type="primary" @click="reset">
							重置
						</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="flex justify_content_end custom_btn">
				<el-button @click="toAdd()"> 新增AI专题 </el-button>
			</div>
			<div class="table_box">
				<tablec :tableData="tableData" :from="from" :loading="loading"></tablec>
			</div>
			<div
				class="flex justify_content_end aligin_items_c table_footer custom_btn"
			>
				<div>
					<pagination
						v-show="total > 0"
						:total="total"
						:page.sync="searchInfo.page"
						:limit.sync="searchInfo.size"
						@pagination="getDataList"
					/>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import tablec from "./tablec.vue";
import ExportExcel from "../../../components/ExportExcel.vue";

import {
	generateAiTopic,
	generateAiTopicHtml,
	submitAiTopic,
	getAiTopicDetail,
	getAiTopicList,
} from "@/api/article";
import { searchMixin } from "@/utils/searchMixin.js";
export default {
	mixins: [searchMixin],
	components: { tablec, ExportExcel },
	name: "",
	data() {
		return {
			tableData: [],
			total: 0,
			loading: false,
			searchInfo: {
				title: "",
				page: 1,
				size: 10,
				status: "999",
				id: "",
			},
			from: 0,
		};
	},
	created() {
		let _obj = JSON.parse(sessionStorage.getItem("aitopicListKey_m"));
		if (_obj) {
			Object.keys(this.searchInfo).forEach((key) => {
				this.searchInfo[key] = _obj[key] || this.searchInfo[key];
			});
		}
		this.getDataList();
	},
	methods: {
		searchBtn() {
			this.searchInfo.page = 1;
			this.getDataList();
		},
		toAdd() {
			this.$router.push({
				path: "/message/aitopicdetail",
				query: { type: "add" },
			});
		},
		getDataList() {
			this.loading = true;
			let _data = Object.assign(this.searchInfo, {});
			sessionStorage.setItem("aitopicListKey_m", JSON.stringify(_data));
			const that = this;
			let tmpParam = { ...this.searchInfo };
			if (tmpParam.status == "999") {
				tmpParam.status = "";
			}
			getAiTopicList(tmpParam)
				.then((res) => {
					this.loading = false;
					console.log(res);
					if (res.code == 200) {
						that.tableData = res.data.data;
						that.total = res.data.total;
					} else {
						that.tableData = [];
						that.total = 0;
					}
					this.loading = false;
				})
				.catch((error) => {
					this.loading = false;
					this.$message.error(error.message);
				});
		},
		reset() {
			this.searchInfo = {
				title: "",
				page: 1,
				size: 10,
				status: "999",
				id: "",
			};
			this.getDataList();
		},
	},
};
</script>

<style scoped></style>
